import api_client from '@/repositories';
import { useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import microsoftRedirectService from './microsoftRedirect.service';

export default function useMicrosoftOauthRedirect() {
	const toast = useToast();
	const history = useHistory();
	const location = useLocation();
	const { t } = useTranslation();
	const client = useQueryClient();

	useEffect(
		function consentMicrosoft() {
			api_client.consent
				.consent({
					authCode: microsoftRedirectService.parseCode(location.search),
					provider: 'MICROSOFT',
				})
				.then(() => {
					const path = microsoftRedirectService.parsePath(location.search);
					history.push(path);
					toast({ isClosable: true,
						title: t('Microsoft calendar connected!'),
						status: 'success',
					});

					client.invalidateQueries();
				})
				.catch((err) => {
					const path = microsoftRedirectService.parsePath(location.search);
					console.error(err);
					history.push(path);
					Sentry.captureException(err);
					toast({ isClosable: true,
						status: 'error',
						title: t('Microsoft calendar sync failed.'),
					});
				});
		},
		// Execute this just on the first render
		[] // eslint-disable-line
	);
}
